const METAL = (a, b, c = a) => `linear-gradient(135deg, ${a} 0%, ${b} 55%, ${c} 100%)`;

const RULES = [
  [/black nickel/, METAL("#6a6a6e", "#2a2a2d", "#55555a")],
  [/black oak/, METAL("#3a302a", "#1f1915")],
  [/red oak/, METAL("#b8744a", "#8a4f2e")],
  [/walnut/, METAL("#6e4a30", "#4a2f1d")],
  [/oak/, METAL("#d4ab7c", "#a87d4f")],
  [/antique brass/, METAL("#b08d4f", "#7a5c2c", "#a58447")],
  [/brass|gold/, METAL("#f3dc8c", "#b8902f", "#e9cf7a")],
  [/copper/, METAL("#e3a37f", "#a0583a", "#d18e68")],
  [/bronze/, METAL("#9a6d43", "#5a3d22", "#87603a")],
  [/antique tin|nickel|tin\b/, METAL("#dcdcd8", "#9c9c97", "#cfcfcb")],
  [/chrome|silver|stainless|alumin/, METAL("#f7f8f9", "#a9adb2", "#e6e8ea")],
  [/gunmetal|charcoal|pewter|graphite/, METAL("#7a7c80", "#3e4044", "#66686c")],
  [/black/, METAL("#3a3a3a", "#141414", "#2a2a2a")],
  [/white/, METAL("#ffffff", "#e9e7e2")],
  [/grey|gray/, METAL("#8d8d8d", "#5c5c5c")],
];

const BRUSHED = "repeating-linear-gradient(90deg, rgba(255,255,255,0.10) 0 1px, transparent 1px 3px)";

export const finishBg = (name) => {
  const parts = name.toLowerCase().split("/").map((p) => RULES.find(([re]) => re.test(p))?.[1]).filter(Boolean);
  if (!parts.length) return null;
  const tone = parts.length > 1 ? `linear-gradient(135deg, transparent 50%, ${parts[1].match(/#\w+/)[0]} 50%), ${parts[0]}` : parts[0];
  return /brushed/i.test(name) ? `${BRUSHED}, ${tone}` : tone;
};

export const getFinishes = (item) => {
  const spec = (item?.specs || []).find((s) => /^(finish|colour|color)$/i.test(s.label));
  return spec ? spec.value.split(",").map((v) => v.trim()).filter((v) => v && finishBg(v)) : [];
};

const Dot = ({ name, size }) => (
  <span title={name} className={`${size} shrink-0 rounded-full ring-1 ring-[#F5F3EF]/20 shadow-[inset_0_1px_2px_rgba(255,255,255,0.35),inset_0_-2px_3px_rgba(0,0,0,0.35)]`}
    style={{ background: finishBg(name) }} />
);

export const FinishDots = ({ item, max = 6 }) => {
  const list = getFinishes(item);
  if (list.length === 0) return null;
  return (
    <div className="mt-3 flex items-center gap-1.5" data-testid={`finish-dots-${item.id}`} aria-label={`Finishes: ${list.join(", ")}`}>
      {list.slice(0, max).map((f) => <Dot key={f} name={f} size="w-4 h-4" />)}
      {list.length > max && <span className="ml-1 text-xs text-[#A09E97]">+{list.length - max}</span>}
    </div>
  );
};

export const FinishChips = ({ item }) => {
  const list = getFinishes(item);
  if (list.length === 0) return null;
  return (
    <div className="mt-8" data-testid="item-finish-chips">
      <p className="font-mono-j text-xs uppercase tracking-[0.2em] text-[#A09E97]">Available in {list.length} finish{list.length > 1 ? "es" : ""}</p>
      <div className="mt-4 flex flex-wrap gap-2">
        {list.map((f) => (
          <span key={f} className="inline-flex items-center gap-2.5 rounded-full border border-[#D4AF37]/20 bg-[#13141C] pl-1.5 pr-4 py-1.5 text-sm text-[#F5F3EF]">
            <Dot name={f} size="w-6 h-6" /> {f}
          </span>
        ))}
      </div>
    </div>
  );
};
